import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { EditorModule, EditorState, Language, Theme } from '../types/editor';

interface EditorActions {
  setActiveModule: (module: EditorModule) => void;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
  setLanguage: (language: Language) => void;
  toggleSidebar: () => void;
  toggleRightPanel: () => void;
}

export const useEditorStore = create<EditorState & EditorActions>()(
  immer((set) => ({
    activeModule: 'ai-architect',
    theme: 'dark',
    language: 'tr',
    sidebarOpen: true,
    rightPanelOpen: false,

    setActiveModule: (module) =>
      set((state) => {
        state.activeModule = module;
      }),

    setTheme: (theme) =>
      set((state) => {
        state.theme = theme;
      }),

    toggleTheme: () =>
      set((state) => {
        state.theme = state.theme === 'dark' ? 'light' : 'dark';
      }),

    setLanguage: (language) =>
      set((state) => {
        state.language = language;
      }),

    toggleSidebar: () =>
      set((state) => {
        state.sidebarOpen = !state.sidebarOpen;
      }),

    toggleRightPanel: () =>
      set((state) => {
        state.rightPanelOpen = !state.rightPanelOpen;
      }),
  }))
);
